import React from 'react';
import Reflux from 'reflux';
import AlertStore from 'stores/alertStore';
import AlertMessage from 'components/alertMessage';

export default React.createClass({
    mixins: [
        Reflux.connect(AlertStore, 'alerts'),
    ],

    getInitialState() {
        return {
            alerts: [],
        };
    },

    render() {
        return (
            <div {...this.props}>
                {this.state.alerts.map(alert => <AlertMessage alert={alert} key={alert.key} />)}
            </div>
        );
    },
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/alerts.jsx